import React from 'react';
import SessionGamesHistory from '../games/SessionGamesHistory';
import { DEFAULT_SCORING } from '../../utils/gameScoreRules';

/**
 * Competitive session Games tab: all session games in card layout.
 */
function GamesTab({
  sessionId,
  viewerPlayerId = null,
  sessionPlayerStatus = null,
  isSessionHost = false,
  onScheduleRematch = null,
  sessionPlayerScheduledGames = null,
  canCorrectScore = false,
  sessionStatus = null,
  scoringConfig = DEFAULT_SCORING,
  playersById = null,
  onScoreCorrected = null,
  gamesRefreshKey = 0,
  localGames = null,
}) {
  return (
    <div className="mt-4 md:mt-6">
      <SessionGamesHistory
        sessionId={sessionId}
        viewerPlayerId={viewerPlayerId}
        sessionPlayerStatus={sessionPlayerStatus}
        sessionPlayerScheduledGames={sessionPlayerScheduledGames}
        canScheduleRematch={Boolean(isSessionHost && onScheduleRematch)}
        onScheduleRematch={onScheduleRematch}
        canCorrectScore={canCorrectScore}
        sessionStatus={sessionStatus}
        scoringConfig={scoringConfig}
        playersById={playersById}
        onScoreCorrected={onScoreCorrected}
        refreshKey={gamesRefreshKey}
        localGames={localGames}
      />
    </div>
  );
}

export default GamesTab;
